import "./CatalogueUnit.scss";
// REACT; ROUTER
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// COMPONENTS & FUNCTIONS

// SVG & IMAGES

// INTERFACES
import { CatalogueUnitProps } from "../../interface/propTypesInterface";
import { DataType, EntryType } from "../../interface/dataTypeInterface";

// NPM INSTALLS
import { v4 as uuid } from "uuid";
import * as FaIcons from "react-icons/fa";

/*
CATALOGUEUNIT COMPONENT INFORMATION
  Some catalogue have subcategories, Those will have buttons on top.
  All data values are loaded in the MAIN component and data gets loaded in based on URL
*/

export default function CatalogueUnit(props: CatalogueUnitProps) {
  // :::::: STATES :::::::
  const [dataset, setdataset] = useState<DataType>();
  const [dataIndex, setdataIndex] = useState(0);
  // ::::: USE HOOKS :::::

  useEffect(() => {
    if (props.data.length <= 1) setdataset(props.data[0]);
  }, [props.data]);

  // ::::: HANDLER FUNCTIONS ::::::
  // Loads the data based on the selection of the subcategory of the catalogue
  const handleSelectData = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    index: number
  ) => {
    const selectedData: DataType = {
      ...props.data[index],
      data: props.data[index].data.map((data) => {
        return {
          ...data,
        };
      }),
    };

    setdataIndex(index);
    setdataset(selectedData);
  };

  // Searches through DataType[] which can consist up to 3 key-value pairs. Filters based on match
  const handleTableSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (dataset) {
      const filteredDataset: DataType = {
        ...props.data[dataIndex],
        data: props.data[dataIndex].data.filter((entry) => {
          for (let index = 0; index < Object.values(entry).length; index++) {
            if (
              Object.values(entry)
                [index].value.toString()
                .toUpperCase()
                .includes(e.target.value.toUpperCase())
            )
              return true;
          }
          return false;
        }),
      };
      setdataset(filteredDataset);
    }
  };

  // Copy selected cell calue to clipboard
  const handleCopyCellValue = (entry: {
    value?: string;
    unit?: string | undefined;
    isImg?: boolean | undefined;
  }) => {
    if (entry.isImg || entry.value === undefined) return;
    const textToClipboard = entry.value;
    navigator.clipboard.writeText(textToClipboard);
    // meTODO: copied to clipboard
  };

  // :::::: JSX ::::::
  return (
    <div className="catalogue">
      {props.data.length > 1 && (
        <nav className="catalogue__datalist">
          {props.data.map((data, i) => (
            <button
              key={data.id}
              onClick={(e) => handleSelectData(e, i)}
              className="rectangular-button inverse-color"
            >
              {data.name}
            </button>
          ))}
        </nav>
      )}
      <h2>{dataset && dataset.name}</h2>
      <h2></h2>
      {dataset?.descriptions?.map((description, i) => {
        return (
          <p
            className="catalogue__description"
            key={description.substring(1, 3) + i}
          >
            {description}
          </p>
        );
      })}
      {dataset && (
        <div className="catalogue__table-container">
          <input
            onChange={handleTableSearch}
            placeholder="search here..."
            className="catalogue__table-search"
          />

          <div className="catalogue__table-container--scroll">
            <table>
              <thead>
                <tr>
                  {dataset &&
                    dataset.data.length > 0 &&
                    Object.keys(dataset.data[0]).map((entry) => (
                      <th id={Object.keys(entry)[0]} key={uuid()}>
                        {entry.replaceAll("_", " ")}
                      </th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {dataset.data.map((data) => {
                  return (
                    <tr key={uuid()} className="pipe__table-row">
                      {Object.values(data).map((entry) => {
                        return (
                          <td
                            key={uuid()}
                            style={entry.isImg ? { textAlign: "center" } : {}}
                          >
                            {entry.isImg ? (
                              <img src={entry.value} alt="unknown data image" />
                            ) : entry.unit ? (
                              `${entry.value} ${entry.unit}`
                            ) : (
                              entry.value
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <p className="catalogue_unit">
            {/* All units in <em>{pipeStandardByID.baseUnit}</em> */}
          </p>
        </div>
      )}
    </div>
  );
}
